'use client';

import { c as _c } from "react/compiler-runtime";
import { useOnboardingSelf, useSelfStepUrl, type UseOnboardingSelfReturn } from '../hooks';
import { AvisoNotificadoModal } from './AvisoNotificadoModal';
import { CriandoContaScreen } from './CriandoContaScreen';
import { EmpresaScreen } from './EmpresaScreen';
import { InicioScreen } from './InicioScreen';
import { OperacaoScreen } from './OperacaoScreen';
import { PresenteScreen } from './PresenteScreen';
import { ProdutosScreen } from './ProdutosScreen';
const renderScreen = (vm: UseOnboardingSelfReturn) => {
  switch (vm.step) {
    case 'empresa':
      return <EmpresaScreen vm={vm} />;
    case 'produtos':
      return <ProdutosScreen vm={vm} />;
    case 'operacao':
      return <OperacaoScreen vm={vm} />;
    case 'criando':
      return <CriandoContaScreen vm={vm} />;
    case 'presente':
      return <PresenteScreen vm={vm} />;
    case 'inicio':
    default:
      return <InicioScreen vm={vm} />;
  }
};
export const OnboardingSelfWizard = () => {
  const $ = _c(12);
  const vm = useOnboardingSelf();
  let t0;
  if ($[0] !== vm.contaCriada || $[1] !== vm.empresaPreenchida || $[2] !== vm.podeAvancarProdutos) {
    t0 = {
      empresaPreenchida: vm.empresaPreenchida,
      produtosEscolhidos: vm.podeAvancarProdutos,
      contaCriada: vm.contaCriada
    };
    $[0] = vm.contaCriada;
    $[1] = vm.empresaPreenchida;
    $[2] = vm.podeAvancarProdutos;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  useSelfStepUrl(vm.step, vm.goTo, t0, vm.rascunhoHidratado);
  let t1;
  if ($[4] !== vm) {
    t1 = renderScreen(vm);
    $[4] = vm;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== vm.avisoNotificadoAberto || $[7] !== vm.fecharAviso) {
    t2 = <AvisoNotificadoModal aberto={vm.avisoNotificadoAberto} onFechar={vm.fecharAviso} />;
    $[6] = vm.avisoNotificadoAberto;
    $[7] = vm.fecharAviso;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};